module.exports = __webpack_public_path__ + "static/media/coding-1853305_640.6ebbf280.jpg";